var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "drive-list" }, [
    _vm.drives.length === 0
      ? _c(
          "div",
          [
            _c("UiAlert", { attrs: { type: "info", dismissible: false } }, [
              _vm._v("\n      " + _vm._s(_vm.noDrivesText) + "\n    "),
            ]),
          ],
          1
        )
      : _c(
          "div",
          [
            _c("h2", [_vm._v(_vm._s(_vm.$tr("drivesFound")))]),
            _vm._l(_vm.drives, function (drive) {
              return _c("KRadioButton", {
                key: drive.id,
                attrs: {
                  label: _vm.enabledDriveLabel(drive),
                  value: drive.id,
                  currentValue: _vm.value,
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("input", drive.id)
                  },
                },
              })
            }),
          ],
          2
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }